<template>
    <div class="page-main">

        <p class="intro">{{ $global.activityTime }}，参与天命*荆州争霸地图，每击杀1个英雄获取1点经验值。累计经验值即可领取相应奖励！</p>

        <div class="gif-view">
            <img src="https://web-resource.17m3.com/m3guo/202209/ck/main.gif">
        </div>

        <div class="reward-view">
            <h6 class="title"></h6>

            <ul>
                <li v-for="(item,index) in pack_config" :key="index">
                    <div class="reward-item"
                    @click="$item_tips(item.id)"><game-item :id="item.id" :num="item.num" :locked="true"></game-item></div>  
                    <!-- <div class="item-name">{{ item.name }}</div>-->
                </li>
            </ul>
        </div>

        <div class="exp-view">
            <div class="info-view">
                <span class="exp-info" v-if="$store.state.userinfo.areaId && $store.state.account.week > 0">本周已获经验值：<b>{{ exp_result() }}/{{ $global.EXP[$store.state.account.week - 1] }}</b></span>
                <span class="exp-info" v-if="$store.state.userinfo.areaId && $store.state.account.week == -1">本周已获经验值：<b>{{ exp_result() }}/500</b></span>
                <span class="exp-info" v-if="$store.state.userinfo.areaId && $store.state.account.week == -2">本周已获经验值：<b>{{ exp_result() }}/2000</b></span>
                <span class="exp-info" v-if="!$store.state.userinfo.areaId">本周已获经验值：<b>0</b></span>
                <div class="u-btn u-rule" @click="$rule_modal()"></div>
            </div>
            
            <div class="exp-bar">
                <div class="bar" :style="{'width' : exp_result()/$global.EXP[$store.state.account.week - 1] * 100 + '%'}"></div>
            </div>
            <div class="time-info">
                <div class="time">本周截止时间：
                    <span id="J-end" v-if="$store.state.login">{{ $global.end[$store.state.account.week - 1] }}</span>
                    <span class="u-btn" v-else @click="$mslogin.open()">登录查看</span>
                </div>
                <div class="time" v-if="$store.state.account.week == 4">领取奖励截止时间：9月30日</div>
            </div>

            <div class="exp-ctrl">
                <div class="u-btn exp-apply" @click="call_expModal"></div>
                <div class="u-btn extra-apply dismiss" v-if="($store.state.account.uflag & 2) == 2"></div>
                <div class="u-btn extra-apply" v-else  @click="$comfirm_Modal()"></div>
            </div>            
        </div>

        <div class="result-view">
            <div class="data-table list-table">
                <table v-if="$store.state.task.length">
                    <tbody id="J-reward">
                        <tr v-for="(item,index) in $store.state.task[0].giftList.slice(now_page * perpage , perpage * (now_page + 1))" :key="index">
                            <th class="exp">{{ $global.level[now_page * perpage + index] }}</th>
                            <th class="r">
                                <div class="reward-pic" :class="{'dismiss' : $store.state.userinfo.areaId && ($store.state.task[0].giftRate > (now_page * perpage + index))}" @click="$item_tips(item.gameGiftId)">
                                    <game-item :id="item.gameGiftId" :num="item.sendNum" :locked="true"></game-item>
                                </div>                               
                            </th>
                            <th class="r-ex">
                                <div class="reward-pic" :class="{'dismiss' : $store.state.userinfo.areaId && ($store.state.task[1].giftRate > (now_page * perpage + index))}" @click="$item_tips($store.state.task[1].giftList[now_page * perpage + index].gameGiftId)">
                                    <game-item :id="$store.state.task[1].giftList[now_page * perpage + index].gameGiftId" :num="$store.state.task[1].giftList[now_page * perpage + index].sendNum" :locked="true"></game-item>
                                </div>                             
                            </th>
                        </tr>
                    </tbody>
                </table>

                <div class="u-btn page prev" @click="prev" :class="{'disabled' : now_page == 0}"></div>
                <div class="u-btn page next" @click="next" :class="{'disabled' : now_page == 3}"></div>
            </div>
            
            <div class="u-btn reward-apply" v-if="$store.state.task.length" :class="{'disabled' : $store.state.userinfo.areaId && ($store.state.task[0].giftRate == $store.state.task[0].finishRate)}" @click="apply_ck"></div>            

        </div>
    </div>
</template>

<style scoped>
.page-main{
    position: relative;
    width: 725px;
    height: 1834px;
    margin: 0 auto;
    padding: 50px 27px 0;
    background-image: url(~@/assets/images/bg-tab-2.png);
    box-sizing: border-box;
    color: #830101;
}

.intro{
    margin-bottom: 30px;
}

.gif-view{
    position: relative;
    width: 660px;
    height: 340px;
    margin: 0 auto 58px;
    background-image: url(~@/assets/images/bg-gif-view.png);
}

.gif-view img{
    position: absolute;
    top: 50%;
    left: 50%;
    /* width: 6.53rem;
    height: 3.86rem; */
    /* transform: scale(.95);
    transform-origin: center; */
    transform: translate(-50%,-50%);
}

.reward-view{
    width: 653px;
    height: 249px;
    margin: 0 auto 80px;
    padding-top: 30px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-reward-list.png);
}

.reward-view .title{
    width: 279px;
    height: 37px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-pack-5.png);    
}

.reward-view ul{
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    padding: 0 40px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84px;
    height: 84px;
    margin-bottom: 40px;
    background-image: url(~@/assets/images/bg-item.png);
}

.exp-view{
    margin-bottom: 77px;
}

.exp-view .info-view {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    padding: 0 16px;
}

.u-btn.u-rule {
    position: relative;
    top: 5px;
    width: 118px;
    height: 27px;
    background-image: url(~@/assets/images/btn-rule.png);
}

.time-info{
    display: flex;
    justify-content: space-between;
    width: 631px;
    margin: 20px auto 35px;
    font-size: 22px;
    color: #830101;
}

.exp-info b{
    font-weight: 400;
    color: #ed2908;
}

.exp-bar {
    position: relative;
    width: 631px;
    height: 20px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-pro.png);
}

.bar {
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 16px;
    transform: translateY(-50%);
    background-image: url(~@/assets/images/bar.png);
    background-size: 631px auto;
    /* border-radius: .6rem; */
}

.exp-ctrl {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 42px;
    margin-top: 20px;
}

.exp-ctrl .u-btn {
    /* width: 2.47rem;
    height: .96rem; */
}

.u-btn.exp-apply {
    width: 231px;
    height: 66px;   
    background-image: url(~@/assets/images/btn-exp-apply.png);
}

.u-btn.extra-apply {
    width: 232px;
    height: 68px;      
    background-image: url(~@/assets/images/btn-extra-apply.png);
}

.u-btn.extra-apply.dismiss{
    background-image: url(~@/assets/images/btn-ck-dismiss.png);
}

.data-table {
    position: relative;
    width: 628px;
    height: 541px;
    padding-top: 74px;
    margin: 0 auto;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-reward-table.png);
}

.data-table table {
    position: relative;
    width: 100%;
    height: 466px;
    font-size: 24px;
}

.data-table table tr {
    height: 20%;
}

.data-table table .exp {
    width: 200px;
    color: #911515;
}

.data-table table .r,
.data-table table .r-ex {
    width: 235px;
}

.data-table table .pic{
    margin: 0 auto;
}

.data-table .pic.dismiss::after{
    display: block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .8);
    background-image: url(~@/assets/images/reward-dismiss.png);
    background-size: 84px auto;
    background-position: center;
    background-repeat: no-repeat;
}

.u-btn.reward-apply {
    width: 231px;
    height: 66px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/btn-reward-apply.png);
}

.list-table .page.u-btn{
    position: absolute;
    top: 50%;
    width: 59px;
    height: 59px;
    transform: translateY(-50%);
    background-repeat: no-repeat;
}
.list-table .page.u-btn.prev{
    left: -20px;
    background-image: url(~@/assets/images/btn-prev.png);
}
.list-table .page.u-btn.next{
    right: -20px;
    background-image: url(~@/assets/images/btn-next.png);
}

.reward-pic{
    position: relative;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.reward-pic.dismiss::after{
    display: block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    background-image: url(~@/assets/images/reward-dismiss.png);
    background-size: 68px auto;
    background-position: center;
    background-repeat: no-repeat;
}
</style>

<script>
export default {
    data (){
        return {
            pack_config : [{name : '',id : 'FP94',num : 1},{name : '',id : 'HL22',num : 1},{name : '',id : 'LP47',num : 1},{name : '',id : 'LQ44',num : 10}],
            now_page : 0,
            perpage : 5,
        }
    },
    created (){
        //this.update_task();
    },
    methods : {
        exp_result (){
            let vm = this;
            let week = vm.$store.state.account.week < 0 ? 4 : vm.$store.state.account.week;
            return Math.min( (vm.$store.state.account.buy +  vm.$store.state.account.killScore) ,  vm.$global.EXP[week - 1]);
        },
        update_task (){
            this.$axios.get(ajax_url_map.task)
            .then(
            res => {
                this.$store.commit("$_setTask", res.data);
            },
            rej => {}
            )
        },        
        prev (){
            return this.now_page = Math.max(0,--this.now_page)
        },
        next (){
            return this.now_page = Math.min(3,++this.now_page)
        },
        apply_ck (){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            //if(this.$store.state.uflag & 2)return this.$toast('您已购买鸡王~');

            //console.log(this.$store.state.task[0].giftRate);

            this.$axios.post(ajax_url_map.apply,{
                code : 1,
            })
            .then(
                res => {
                    this.$success_Apply();
                    this.$store.commit("$_setRewardStatus", this.$store.state.task[0].giftRate);
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },
        call_expModal(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if((this.$store.state.account.buy +  this.$store.state.account.killScore) >= this.$global.EXP[this.$store.state.account.week - 1] )return this.$toast('本周您已经达到经验上限');
            
            this.$buy_Modal();
        },        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/main.vue